import { api } from "../../../config";
import { GetRubricatedBookFilter, GetRubricatedBooksListServiceResponse, PostDownloadRubricatedBookEntryParams,  PostDownloadRubricatedBookResponse,  RubricatedBook } from "../../interfaces/services/rubricated-books";
import { getError, getUserInfo } from "../../utils";
import CustomHttpClient from "../customHttpClient";
const customHttpClient = CustomHttpClient({
    baseUrl: 'productores',
  });
const ProductionService = {
    
    async getRubricatedBooks( filters: GetRubricatedBookFilter): Promise<GetRubricatedBooksListServiceResponse> {
        const url = 'librosRubricados';
        
        try {
            const response = await customHttpClient.get(url);            
            let rubricatedBooksResponse = response.data;
            const filteredData = {
                registros: rubricatedBooksResponse.registros.filter((item:RubricatedBook) => {

                    const yearMatch = !filters.year || item.anio === filters.year;

                    const monthMatch = !filters.month || item.mes === filters.month.padStart(2, '0');

                    const fortnightMatch = !filters.fortnight || item.quincena === filters.fortnight;

                    return yearMatch && monthMatch && fortnightMatch;
                }),
            };

            return filteredData;
        }catch(error){            
            throw new Error(getError(error));
        }
    },

    async postDownloadRubricatedBook( entryParams: PostDownloadRubricatedBookEntryParams): Promise<PostDownloadRubricatedBookResponse> {
        const url = 'descargaLibrosRubricados';
        const body = {
            ...entryParams,
            ...getUserInfo(),
        }
        try {

            
            const response = await customHttpClient.post<PostDownloadRubricatedBookResponse>(url, body);
            
            let rubricatedBooksResponse = response.data;

            return rubricatedBooksResponse;
        }catch(error){            
            throw new Error(getError(error));
        }
    }
}
export default ProductionService;
